import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { pendoTags } from '../../../../../constants/pendoTags';
import { useSteps } from '../../../../../hooks/useSteps';
import DeliveryOption from '../delivery-option/delivery-option.component';

const SendAsEmail: FC = () => {
  const { t } = useTranslation('digital-forms-sending-experience');
  const { goToNextStep } = useSteps();

  return (
    <DeliveryOption
      icon='email-small'
      displayName={t('Email')}
      deliveryMethod='email'
      onClick={goToNextStep}
      trackingId={pendoTags.steps.deliveryMethod.direct.via.email}
    />
  );
};

export default SendAsEmail;
